import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, image, path = "", type = "website", canonical, article, noindex = false, children }) {
  const fullTitle = title ? `${title} · NC Mycology` : "NC Mycology LLC · Mushroom Cultures, Grow Bags & Guides";
  const url = canonical || `https://nc-mycology.com${path}`;
  const desc = description || "Clean, lab-prepared liquid mushroom cultures, grow bags, bucket kits, and cultivation guides from North Carolina.";
  const OG_DEFAULT = "https://nc-mycology.com/og-banner.png";
  const absImage = image ? (image.startsWith("/") ? `https://nc-mycology.com${image}` : image) : OG_DEFAULT;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="NC Mycology" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta property="og:image" content={absImage} />
      <meta name="twitter:image" content={absImage} />
      {article?.published_at && <meta property="article:published_time" content={article.published_at} />}
      {article?.category && <meta property="article:section" content={article.category} />}
      {children}
    </Helmet>
  );
}
